import React, { useRef, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import IconBox from '../IconBox';

import 'swiper/swiper-bundle.css';

export default function ServiceSlider({ data }) {
  // Create a ref to hold the Swiper instance
  const [showLeftIcon, setShowLeftIcon] = useState(false);
  const [showRightIcon, setShowRightIcon] = useState(true);

  // Create a ref to hold the Swiper instance
  const swiperRef = useRef(null);

  const onSlideChange = () => {
    const swiperInstance = swiperRef.current && swiperRef.current.swiper;
    if (swiperInstance) {
      const isBeginning = swiperInstance.isBeginning;
      const isEnd = swiperInstance.isEnd;

      setShowLeftIcon(!isBeginning);
      setShowRightIcon(!isEnd);
    }
  };

  useEffect(() => {
    const swiperInstance = swiperRef.current && swiperRef.current.swiper;

    if (swiperInstance) {
      swiperInstance.on('slideChange', onSlideChange);

      return () => {
        swiperInstance.off('slideChange', onSlideChange);
      };
    }
  }, [data]);

  // Function to navigate to the next slide
  const goToNextSlide = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  // Function to navigate to the previous slide
  const goToPrevSlide = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };
  return (
    <>
      <div className="service-slider-container" style={{ width: '100%' }}>
        {showLeftIcon && (
          <div className="left-slider">
            <a className="cs_down_btn cs_center cs_primary_color" onClick={goToPrevSlide} style={{
              cursor: "pointer",
              position: "absolute",
              
              // top: '-50px',
              // transform: 'translateY(-50%)',
              zIndex: showRightIcon ? 'auto' : 1
            }}>
              {/* Left arrow SVG */}
              <svg style={{ transform: "rotate(90deg)" }}
                width={8}
                height={33}
                viewBox="0 0 8 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.64645 32.3536C3.84171 32.5488 4.15829 32.5488 4.35355 32.3536L7.53554 29.1716C7.7308 28.9763 7.7308 28.6597 7.53554 28.4645C7.34027 28.2692 7.02369 28.2692 6.82843 28.4645L4 31.2929L1.17157 28.4645C0.976312 28.2692 0.65973 28.2692 0.464467 28.4645C0.269205 28.6597 0.269205 28.9763 0.464467 29.1716L3.64645 32.3536ZM3.5 2.18557e-08L3.5 32L4.5 32L4.5 -2.18557e-08L3.5 2.18557e-08Z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </div>
        )}
        <Swiper
          ref={swiperRef}
          style={{ padding: '20px 10px 40px 10px', position: "relative", width:"90%"}}
          slidesPerView={1}
          spaceBetween={24}
          speed={800}
          pagination={{
            clickable: true,
          }}
          navigation={false}
          modules={[Pagination, Navigation]}
          breakpoints={{
            500: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
            991: {
              slidesPerView: 3,
              spaceBetween: 15,
            },
            1750: {
              slidesPerView: 4,
            },
          }}
        >
          {data?.map((item, index) => (
            <SwiperSlide key={index} className="custom-swiper" style={{width: "400px"}}>
              <IconBox {...item} shapeClass={`cs_shape_${index + 1}`} />
            </SwiperSlide>
          ))}
        </Swiper>
        {showRightIcon && (
          <div className="right-slider">
            <a className="cs_down_btn cs_center cs_primary_color" onClick={goToNextSlide} 
            style={{ cursor: "pointer", position: "absolute", zIndex: showLeftIcon ? 'auto' : -5,
            // top: '-90px', 
            }}>
              {/* Right arrow SVG */}
              <svg
                style={{ transform: 'rotate(-90deg)' }}
                width={8}
                height={33}
                viewBox="0 0 8 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.64645 32.3536C3.84171 32.5488 4.15829 32.5488 4.35355 32.3536L7.53554 29.1716C7.7308 28.9763 7.7308 28.6597 7.53554 28.4645C7.34027 28.2692 7.02369 28.2692 6.82843 28.4645L4 31.2929L1.17157 28.4645C0.976312 28.2692 0.65973 28.2692 0.464467 28.4645C0.269205 28.6597 0.269205 28.9763 0.464467 29.1716L3.64645 32.3536ZM3.5 2.18557e-08L3.5 32L4.5 32L4.5 -2.18557e-08L3.5 2.18557e-08Z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </div>
        )}
      </div>
    </>
  );
}